module.exports = __webpack_public_path__ + "resources/img/zoom_server_architecture_and_data_flow.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/img/zoom_server_architecture_and_data_flow.png
// module id = 1273
// module chunks = 0